/**
 * Header JavaScript
 * - Scroll behavior
 * - Mobile menu toggle
 */

(function() {
  'use strict';

  // Scroll behavior: scheidingslijn + schaduw pas na scrollen (bovenaan pagina = geen lijn)
  function initHeaderScroll() {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    function syncScroll() {
      const y = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
      /* Pas vanaf echte scroll: kleine drempel voorkomt subpixel-jitter; geen lijn bovenaan */
      if (y > 2) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', syncScroll, { passive: true });
    window.addEventListener('resize', syncScroll, { passive: true });
    window.addEventListener('pageshow', syncScroll);
    /* Na paint (o.a. theme editor iframe) opnieuw meten */
    requestAnimationFrame(function () {
      syncScroll();
      requestAnimationFrame(syncScroll);
    });
    syncScroll();
  }

  // Mobile menu toggle
  function initMobileMenu() {
    const toggle = document.querySelector('[data-mobile-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');
    
    if (!toggle || !menu) return;

    const menuIcon = toggle.querySelector('.menu-icon');
    const closeIcon = toggle.querySelector('.close-icon');

    toggle.addEventListener('click', () => {
      const isOpen = menu.classList.contains('menu-open');
      
      if (isOpen) {
        menu.classList.remove('menu-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (menuIcon) menuIcon.classList.remove('hidden');
        if (closeIcon) closeIcon.classList.add('hidden');
      } else {
        menu.classList.add('menu-open');
        menu.style.maxHeight = menu.scrollHeight + 'px';
        toggle.setAttribute('aria-expanded', 'true');
        if (menuIcon) menuIcon.classList.add('hidden');
        if (closeIcon) closeIcon.classList.remove('hidden');
      }
    });
    
    // Sluit menu bij klik buiten menu
    document.addEventListener('click', (e) => {
      if (!toggle.contains(e.target) && !menu.contains(e.target)) {
        if (menu.classList.contains('menu-open')) {
          menu.classList.remove('menu-open');
          toggle.setAttribute('aria-expanded', 'false');
          if (menuIcon) menuIcon.classList.remove('hidden');
          if (closeIcon) closeIcon.classList.add('hidden');
        }
      }
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initHeaderScroll();
      initMobileMenu();
    });
  } else {
    initHeaderScroll();
    initMobileMenu();
  }
})();

